module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Heavy.6ad37157.woff2";